
export const appendClassNames = (basis, payload, caller = 'unknown') => {

    const append = (basis, className) => {
        return className ? `${basis} ${className}` : basis;
    };

    switch(true) {
        case typeof basis !== 'string':
            return `class not provided by caller =${ caller }=`;
        case Array.isArray(payload):
            return payload.reduce((res, className) => {
                return append(res, className);
            }, basis);
        case typeof payload === 'string':
            return append(basis, payload);
        default:
            return basis;
    }
};